import { RcFile } from 'antd/es/upload';

/**
 * convert file into base64
 * @param {*} file
 * @returns
 */

export const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader?.result as string);
    reader.onerror = error => reject(error);
  });
